<template lang="pug">
    div(class="document")
        div()
            div(style="display:flex; justify-content:space-between")
                Ticker(:stockId="research.stock_id")
                WatchlistAddTo(:stocks="[research]" :page="'home'")
            div(@click="gotoResearch(research)" class="content mt-2" v-html="research.content" style="height:515px; border:0px solid;")
</template>

<script>
import Ticker from './../../components/Ticker.vue';
import WatchlistAddTo from './../../components/WatchlistAddTo.vue';

export default {
    name: 'ResearchNotAddedView',
    props: {
        research: Object
    },
    components: {
        Ticker,
        WatchlistAddTo
    },
    methods: {
        gotoResearch(item) {
            console.log(item);

            this.$router.push({ name: 'landing-page.stock-detail', params: { stock_id: item.stock_id }, query: { openResearch: 1 } });
        }
    }
}
</script>

<style scoped>

.document {
    padding: 8px;
    width: calc(100% / 5);
}

.document > div {
    padding: 8px;
    height: 300px;
    border-radius: 8px;
    background-color: white;
    border: 1px #f4f4f4 solid;
    box-shadow: 0 0 5px rgba(0,0,0,.2);
    overflow: hidden;
    cursor: pointer;
}

.document > div:hover {
    border-color: rgba(20, 75, 77, .6);
    box-shadow: 0 0 5px rgba(20, 75, 77, .8);
}

.content {
    zoom: .5;
}
</style>
